import Hero from '../components/Paint/Hero';
import Categories from '../components/Paint/Categories';
import MostSellingPaintProduct from '../components/Paint/MostSellingPaintProduct';

const Paint = () => {
  return (
    <div>
      <Hero />
      <Categories />
      <MostSellingPaintProduct />
    </div>
  );
};

export default Paint;
